import { Button } from "antd";
import Text from "components/Text";
import styled from "styled-components";
import { CloseCircleFilled } from '@ant-design/icons';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import { isPremium } from "utils";

const StyledLayer = styled.div`
  width: 100%;
  height: 100%;
  z-index: 990;
  position: absolute;
  opacity: 0.9;
  background: black;
  top: 0;
  left: 0;
`;

const StyledContent = styled.div`
  position: absolute;
  z-index: 999;
  text-align: center;
  width: 100%;

  @media screen and (min-width: 960px) {
    img {
      width: 50% !important;
    }
  }
`;

/**
 * IkomModal
 * @param {*} props 
 * @returns 
 */
const IkomModal = (props) => {
  const imgSrc = `${process.env.REACT_APP_S3_FILES_URL}${props.mount.output}`

  let mountName = '';
  props.mount._shootings.forEach((shooting) => {
    mountName += `${shooting.name}, `
  })

  mountName = mountName.slice(0, -2);

  return (
    <>
      <CloseCircleFilled style={{ color: 'white', position: 'absolute', right: 10, top: 10, zIndex: 99999, fontSize: 26 }}  onClick={props.handleOnClose} />
      <StyledLayer onClick={props.handleOnClose} />
      <StyledContent>
        <div style={{ width: '75%', margin: 'auto'}}>
          
          <Text size={16} color="white" align="center">{mountName}</Text>

          <img src={imgSrc} style={{ width: '100%' }} alt={props.title} />
          
          <Text onClick={() => props.handleOnDownload(imgSrc)} underline color="white" align="center" style={{ cursor: 'pointer', marginTop: 20  }}>Télécharger</Text>
          {
            props.mount._effect && isPremium(props.auth.tenant) && (
              <Button type="primary" style={{ marginTop: 10 }} onClick={() => props.handleOnSelectMount(props.mount)}>Imprimer sur un support</Button>
            )
          }
        </div>
      </StyledContent>
    </>
  )
}

const stateToProps = state => ({
  auth: state.auth
})

export default connect(stateToProps)(withTranslation()(IkomModal));